import * as React from 'react';

import { ChevronRight } from 'lucide-react';
import { PaginationLink } from './pagination-link';

export const PaginationNext = (
    props: React.ComponentProps<typeof PaginationLink>,
) => (
    <PaginationLink aria-label="Go to next page" type="next" {...props}>
        <ChevronRight />
    </PaginationLink>
);

PaginationNext.displayName = 'PaginationNext';
